//* Libraries imports
import z from "zod";

//* Schemas imports
import { nameSchema } from "../../name";


export const fullResult = z.object({
  resultado: z.object({
    estudante: z.object({
      cpf: z.string(),
      nome: nameSchema,
      numero_inscricao: z.string(),
      certificado: z
        .object({
          url: z.string(),
          filename: z.string(),
        })
        .optional(),
    }),

    desempenho_prova: z.discriminatedUnion("tipo_prova", [
      // Prova objetiva
      z.object({
        total_questoes: z.number(),
        questoes_objetivas: z.object({
          total: z.number(),
          corretas: z.number(),
          taxa_acerto: z.number().min(0).max(100),
        }),
        tipo_prova: z.literal("objetiva"),
        respostas_corretas: z.number(),
        taxa_acerto_geral: z.number().min(0).max(100),
      }),

      // Prova dissertativa
      z.object({
        total_questoes: z.number(),
        questoes_dissertativas: z.object({
          total: z.number(),
          respondidas: z.number(),
          corrigidas: z.number(),
          pendentes: z.number(),
          taxa_correcao: z.number().min(0).max(100),
          nota: z.number().min(0),
        }),
        tipo_prova: z.literal("dissertativa"),
        respostas_corretas: z.number(),
        taxa_acerto_geral: z.number().min(0).max(100),
      }),
    ]),

    respostas: z.string().nullable().optional(),

    questoes: z.array(
      z.discriminatedUnion("type_questao", [
        z.object({
          id: z.number(),
          name: z.string(),
          type_questao: z.literal("simples"),
          categoria: z.object({
            name: z.string(),
          }),
          alternativas: z.array(
            z.object({
              id: z.number(),
              name: z.string(),
              letra: z.string(),
            })
          ),
          correta: z.string().nullable(),
          resposta_estudante: z.string().optional(),
          tipo_resposta: z.string().optional(),
        }),

        z.object({
          id: z.number(),
          name: z.string(),
          type_questao: z.literal("dissertativa"),
          categoria: z.object({
            name: z.string(),
          }),
          resposta_estudante: z.string(),
          tipo_resposta: z.string(),
          correcao_dissertativa: z.object({
            nota_total: z.number(),
            foi_corrigida: z.boolean(),
            comentario_geral: z.string(),
            c1: z
              .object({
                nota: z.number().min(0).max(10),
                justificativa: z.string(),
              })
              .optional(),
            c2: z
              .object({
                nota: z.number().min(0).max(10),
                justificativa: z.string(),
              })
              .optional(),
            c3: z
              .object({
                nota: z.number().min(0).max(10),
                justificativa: z.string(),
              })
              .optional(),
            c4: z
              .object({
                nota: z.number().min(0).max(10),
                justificativa: z.string(),
              })
              .optional(),
            c5: z
              .object({
                nota: z.number().min(0).max(10),
                justificativa: z.string(),
              })
              .optional(),
          }),
        }),

        z.object({
          id: z.number(),
          name: z.string(),
          type_questao: z.literal("conjunto"),
          categoria: z.object({
            name: z.string(),
          }),
          questoes: z.array(
            z.object({
              id: z.number(),
              name: z.string(),
              type_questao: z.literal("simples"),
              categoria: z.object({
                name: z.string(),
              }),
              alternativas: z.array(
                z.object({
                  id: z.number(),
                  name: z.string(),
                  letra: z.string(),
                })
              ),
              correta: z.string().nullable(),
              resposta_estudante: z.string().optional(),
              tipo_resposta: z.string().optional(),
            })
          ),
        }),
      ])
    ),
  }),
});

export type FullResult = z.infer<typeof fullResult>;



